// index.js
import React, { useState, useEffect } from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { translatory, loadTranslatoryEdit } from './context/i18next'
import App from './App'
import Homepage from './Homepage'
import Trucker from './Trucker'
import { UserProvider } from './context/UserContext'
import { GlobalProvider } from './context/GlobalContext'
import GlobalOverlay from './components/GlobalOverlay'
import CookieConsentManager from './cookies/CookieConsentManager.js'
import initializeTagManager from './cookies/googleTagManager.js'
import { initializeGoogleAnalytics } from './cookies/initializeGoogleAnalytics.js'


function ConsentManagerContainer() {
  const [showBanner, setShowBanner] = useState(false)
  const [isGATrackingAllowed, setIsGATrackingAllowed] = useState(
    () => JSON.parse(localStorage.getItem('user_ga_consent')) ?? null
  )
  const [isGTMTrackingAllowed, setIsGTMTrackingAllowed] = useState(
    () => JSON.parse(localStorage.getItem('user_gtm_consent')) ?? null
  )

  const handleGAConsentChange = (consent) => {
    setIsGATrackingAllowed(consent)
    localStorage.setItem('user_ga_consent', JSON.stringify(consent))
  }

  const handleGTMConsentChange = (consent) => {
    setIsGTMTrackingAllowed(consent)
    localStorage.setItem('user_gtm_consent', JSON.stringify(consent))
  }

  useEffect(() => {
    if (isGATrackingAllowed !== null) {
      initializeGoogleAnalytics(isGATrackingAllowed)
    }
    if (isGTMTrackingAllowed !== null) {
      initializeTagManager(isGTMTrackingAllowed)
    }
  }, [isGATrackingAllowed, isGTMTrackingAllowed])

  return (
    <CookieConsentManager
      showBanner={showBanner}
      setShowBanner={setShowBanner}
      onGAConsentChange={handleGAConsentChange}
      onGTMConsentChange={handleGTMConsentChange}
    />
  )
}

function Root() {
  return (
    <BrowserRouter>
      <GlobalProvider>
        <UserProvider>
          <ConsentManagerContainer />
          <Routes>
            <Route path="/" element={<Homepage />} />
              <Route path="/app/*" element={<App />} />
            <Route path="/register/*" element={<Trucker />} />
            <Route path="*" element={<Homepage />} />
          </Routes>
          <GlobalOverlay />
        </UserProvider>
      </GlobalProvider>
    </BrowserRouter>
  )
}

const root = ReactDOM.createRoot(document.getElementById('root'))

translatory(() => {
  loadTranslatoryEdit()
  root.render(<Root />)
})
translatory(() => {
  loadTranslatoryEdit()
  root.render(<Root />)
})